// test267
(267 && 0);
